module.exports = __webpack_public_path__ + "img/Chloe Huang.e97ca777.jpg";